import { useShop } from "@/hooks/use-shop";
import { formatCurrency } from "@/lib/utils";

export function Currency({ amount }: { amount: number }) {
  const { data: shop } = useShop();
  if (!shop) {
    return null;
  }

  return <>{formatCurrency(amount, shop.currencyCode ?? "HUF")}</>;
}
